import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import StlViewer from './stlViewer';
import { modelsNeedingSnapshot, stlModelUrl } from '../../lib/stlModels';
import { uploadImageFile } from '../../lib/pasteImageUpload';

// Generates a PNG preview image for an entity's STL models, offscreen.
// Entity-agnostic: `object` is the record (product/article) and `objectName`
// selects the store (`stores[objectName + 'Store']`). The offscreen viewer fetches
// the model through `stlSrc()` (the app's own server) so it's not CORS-blocked.
@observer
class StlSnapshotter extends Component {
    constructor(props) {
        super(props);
        this.state = { generating: false };
        this.inFlight = {}; // md5 -> true, guards against double-generation
        this.unmounted = false;
    }

    componentWillUnmount() {
        this.unmounted = true;
    }

    handleSnapshot = async (blob, model) => {
        const { stores, object, objectName = 'product' } = this.props;
        const store = stores[`${objectName}Store`];
        if (!blob || !object || !object.id || !model || !model.md5 || !store) {
            return;
        }
        if (this.inFlight[model.md5]) {
            return;
        }
        this.inFlight[model.md5] = true;
        if (!this.unmounted) {
            this.setState({ generating: true });
        }
        try {
            const file = new File([blob], `model-${model.md5}.png`, { type: 'image/png' });
            const uploaded = await uploadImageFile(file);
            await store.addArrayObject({
                newObject: { ...uploaded, sourceModelMd5: model.md5 },
                object,
                field: 'images',
                objectName,
            });
        } catch (err) {
            // Best-effort: a failed snapshot just leaves the card on its placeholder.
        } finally {
            delete this.inFlight[model.md5];
            if (!this.unmounted) {
                this.setState({ generating: false });
            }
        }
    };

    render(props) {
        const { object, objectName = 'product' } = props;
        if (!object || !object.id) {
            return null;
        }
        const pending = modelsNeedingSnapshot(object.models, object.images);
        if (pending.length === 0) {
            return null;
        }
        const model = pending[0];
        // Render ONE offscreen viewer that captures a PNG for the first pending model.
        return (
            <div
                class='stl-snapshotter'
                style='position:absolute; left:-99999px; top:0; width:400px; height:400px; overflow:hidden;'
                aria-hidden='true'
            >
                <StlViewer
                    key={model.md5}
                    src={stlModelUrl(`${objectName}s`, object.id, model.md5)}
                    interactive={false}
                    onSnapshot={blob => this.handleSnapshot(blob, model)}
                    style='width:400px; height:400px;'
                />
            </div>
        );
    }
}

export default StlSnapshotter;
